<template>
  <div class="arrear-cancel">
    <div class="searchbox order_searchbox">
      <form action="#" method="get" class="form-inline form-float">
        <div class="form-group">
          <label for>车牌号:</label>
          <input
            v-model="search.carNumber"
            class="form-control"
            type="text"
            size="12"
          />
        </div>
        <div class="form-group">
          <label for="bdate">创建时间:</label>
          <bosk-shortcut-date
            v-on:current-date-change="onCurrentDateChange"
          ></bosk-shortcut-date>
          <!-- <el-date-picker
                clearable
                v-model="search.entryDate"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              ></el-date-picker> -->
        </div>
        <!-- <div class="form-group">
              <label for="bdate">离场时间:</label>
              <el-date-picker
                clearable
                value-format="yyyy-MM-dd HH:mm:SS"
                v-model="search.exitDate"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              ></el-date-picker>
            </div> -->
        <div class="form-group others">
          <span class="search_btn">
            <button
              @click="searchList"
              type="button"
              class="btn btn-primary"
              id="search_btn"
            >
              查询
            </button>
          </span>
          <!-- <span class="download_btn">
                <el-button type="primary" size="small" @click="downloadExcel"
                  >导出</el-button
                >
              </span> -->
        </div>
      </form>
    </div>
    <div class="list-right">
      <el-table
        v-loading="loading"
        ref="table"
        border
        :data="tableListData.rows"
        height="100%"
        width="100%"
        :header-cell-style="tableHeaderStyle"
        :cell-style="styleObj"
        @selection-change="onSelectionChange"
        show-summary
        :summary-method="getSummaries"
      >
        <el-table-column
          show-overflow-tooltip
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="停车道路"
          prop="parkingName"
        >
        </el-table-column>
        <el-table-column show-overflow-tooltip label="岗位名称" prop="areaName">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="150px"
          label="订单号"
          prop="orderNum"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="150px"
          label="车牌号"
          prop="carNumber"
        >
        </el-table-column>
        <el-table-column
          width="150px"
          label="入场时间"
          prop="beginDate"
        ></el-table-column>
        <el-table-column
          width="150px"
          label="离场时间"
          prop="endDate"
        ></el-table-column>

        <el-table-column
          width="150px"
          label="停车时长"
          prop="parkingLongTime"
        ></el-table-column>

        <el-table-column
          show-overflow-tooltip
          label="金额"
          prop="realMoney"
        ></el-table-column>

        <el-table-column
          show-overflow-tooltip
          label="操作类型"
          prop="operDesc"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="提交时间"
          prop="crtTime"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="审核人"
          prop="approvedName"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="审核时间"
          prop="approvedTime"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="操作状态"
          prop="auditStatusName"
        ></el-table-column>
        <!-- <el-table-column show-overflow-tooltip label="操作" width="250px">
          <template slot-scope="scope">
            <button
              type="button"
              @click="showPhoto(scope.row.platenumImage)"
              class="photo"
            >
              查看图片
            </button> -->
        <!-- <button
                  type="button"
                  v-bind:class="[
                    scope.row.attr1 !== '是' ? 'is-gray' : '',
                    'operate-button',
                  ]"
                  :disabled="scope.row.attr1 !== '是'"
                  @click="onEtcPayBtn(scope.row)"
                >
                  追缴
                </button> -->
        <!-- </template>
        </el-table-column> -->
      </el-table>
    </div>

    <!--查看图片-->
    <div ref="imgDialog" class="imgDialog">
      <el-dialog
        ref="show"
        height="80%"
        :visible.sync="photoDialogVisible"
        :show-close="false"
        @closed="hiddenShade"
        @opened="showImg"
      >
        <div slot="footer">
          <span v-show="photoY" ref="spanImg" class="img-container">
            <img ref="img1" src width="50%" height="auto" />
            <img ref="img2" src width="50%" height="auto" />
          </span>
          <span class="photoN" v-show="photoN">暂无图片</span>
        </div>
      </el-dialog>
    </div>
    <Page
      v-on:pagination="receivePaginationData"
      v-bind:pageObj="pageObj"
    ></Page>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

import { queryOrderExceptByPageExt } from "@/api/url";

import Page from "@/page/commons/page";
import { MessageBox } from "element-ui";
import dayjs from "dayjs";

export default {
  data() {
    return {
      styleObj: {
        "text-align": "center",
      },

      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      photoDialogVisible: false,
      photoY: false,
      photoN: false,
      photoShow: false,
      imgList: [],
      search: {
        page: 1,
        limit: 10,
        carNumber: "",
        crtTime: null,
        operType: "exception",
        status: "approved",
      },
      tableListData: {},
      pageObj: {},
      selectedList: [],
      totalMap: {},
      loading: false,
    };
  },
  components: {
    Page,
  },

  created: function() {},
  mounted: function() {
    this.search.page = 1;
    this.tableList(this.search.page);
  },

  methods: {
    ...mapMutations("tabNavigation", ["delNavigation"]),
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.page = v1;
      this.search.limit = v2;
      this.tableList(this.search.pageNumber);
    },
    onSelectionChange(val) {
      this.selectedList = [...val];
    },

    tableList: function(curPage) {
      this.loading = true;
      const _this = this;
      let params = { ...this.search, page: curPage };
      if (!params.carNumber) {
        delete params.carNumber;
      }
      if (params.crtTime) {
        params = {
          ...params,
          crtTime: JSON.stringify(
            params.crtTime.map((date) => this.formatDate(date))
          ),
        };
      }
      this.$get(queryOrderExceptByPageExt(), {
        ...params,
      })
        .then((data) => {
          if (data.status != 200) return;
          //翻页
          var rows = data.data.rows;
          var pageObj = {
            curIndex: data.data.offset,
            rowsCount: data.data.total,
          };
          _this.pageObj = { ...pageObj };
          _this.tableListData = {
            ...data?.data,
            rows: data?.data?.rows ?? {},
          };
          _this.totalMap = data?.data?.totalMap ?? {};
        })
        .finally(() => {
          this.loading = false;
        });
    },
    searchList: function() {
      this.search.page = 1;
      this.tableList(this.search.page);
    },

    showPhoto(url) {
      this.photoDialogVisible = true;
      const urls = url?.split(",") ?? [];

      this.$refs.imgDialog.style.height = "100vh";
      this.$refs.imgDialog.style.width = "100vw";
      this.$refs.imgDialog.style.background = "rgba(0,0,0,0.5)";
      this.$refs.imgDialog.style.position = "fixed";
      this.$refs.imgDialog.style.top = 0 + "px";
      this.$refs.imgDialog.style.left = 0 + "px";

      if (urls.length <= 0) {
        this.photoY = false;
        this.photoN = true;
      } else {
        this.photoY = true;
        this.photoN = false;

        this.$refs.img1.src = urls[0];
        this.$refs.img2.src = urls[1];
      }

      // this.imgDialog.url = url;
      this.$refs.show.open();
      // console.log(img)
      // ctx.drawImage(img,0,0);
      // window.open(url,'_blank');

      // this.imgViewerVisible = true;
      // this.imgList = url.split(",");
      // const m = (e) => {
      //   e.preventDefault();
      // };
      // document.body.style.overflow = "hidden";
      // document.addEventListener("touchmove", m, false); //禁止页面滑动
    },
    hiddenShade() {
      this.$refs.imgDialog.style.height = 0 + "px";
      this.$refs.imgDialog.style.width = 0 + "px";
    },
    showImg() {
      // console.log("6666")
    },

    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = "总计";
        }

        if (index === 8) {
          sums[index] = this.totalMap?.shouldMoneyTotal ?? 0;
        }
      });
      return sums;
    },
    formatDate(date) {
      return dayjs(date).format("YYYY-MM-DD");
    },
    onCurrentDateChange(v) {
      this.search.crtTime = v ? [...v] : null;
    },
  },
};
</script>
<style scoped>
.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}

.searchbox {
  background: #f9f9fb;
  /* height:130px;
              line-height:45px; */
  border-bottom: 10px solid #eff2f7;
  /* height:150px; */
  padding: 10px 10px 0 10px;
}

.refresh {
  display: inline-block;
}

.bread_container {
  display: inline-block !important;
  border: none !important;
  padding: 0 !important;
}

/* .photo{
              width:60px;
              font-size:12px;
              background:#409EFF;
              color:white;
              height:20px;
              line-height:20px;
              
          } */
.imgDialog {
  overflow: hidden;
}
button.photo {
  height: 22px;
  line-height: 22px;
  color: #278cd8;
  background: none;
  font-size: 12px;
  margin-right: 5px;
}

.photoN {
  width: 350px;
  line-height: 300px;
  height: 300px;
  text-align: center;
  display: inline-block;
}

.imgDialog {
  animation: opacity2 3s;
  -webkit-animation: opacity2 3s;
  -moz-animation: opacity2 3s;
}

@keyframes opacity2 {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

@-webkit-keyframes opacity2 {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

@-moz-keyframes opacity2 {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

button.gray {
  color: gray;
}
.form-group {
  margin-bottom: 10px;
}
.gap {
  margin-right: 5px;
}
</style>
<style>
.arrear-cancel .el-date-editor {
  width: auto;
}
.arrear-cancel .el-date-editor.el-input__inner {
  max-width: none;
}
.arrear-cancel .el-date-editor .el-range-input {
  font-size: 12px !important;
}

.arrear-cancel .el-date-editor .el-range-separator {
  font-size: 12px !important;
}

.arrear-cancel .imgDialog .el-dialog__header {
  display: none;
  padding: 0;
}

.arrear-cancel .imgDialog .el-dialog__body {
  padding: 0 !important;
}

.arrear-cancel .imgDialog .el-dialog__footer {
  padding: 0 !important;
}

.arrear-cancel .searchbox .el-select {
  width: 150px !important;
}

.arrear-cancel .order_searchbox .form-control {
  width: 150px;
}
.arrear-cancel .order_searchbox form {
  height: auto;
}

.arrear-cancel .el-dialog {
  margin-top: 10vh !important;
}

/* .el-dropdown-link {
           display: inline-block;;
          cursor: pointer;
          color:white;
          background:#278cd8;
          height:34px;
          border-radius: 5px;
          padding-left:5px;
          font-size: 12px;
          line-height:37px;
          width:90px;
        } */
.arrear-cancel .el-icon-arrow-down {
  font-size: 12px;
}

.arrear-cancel .dowload {
  padding-left: 10px;
  display: inline-block;
}

.arrear-cancel .img-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 20px 0 20px 20px;
}

.arrear-cancel img {
  overflow: hidden;
}

.arrear-cancel .img-container img {
  box-sizing: border-box;
  padding-right: 20px;
}

.arrear-cancel .searchbox .form-inline {
  overflow: auto;
}
.arrear-cancel .is-gray {
  color: #666;
  cursor: not-allowed;
}
.arrear-cancel .list-right{
  height: calc(100vh - 270px)
}
</style>
<style>
.arrear-cancel .modify-plate .el-input__inner {
  height: 40px;
}
.arrear-cancel .modify-plate .el-select {
  width: 100%;
}

.arrear-cancel .el-table__footer-wrapper tbody td.el-table__cell {
  text-align: center;
  color: red;
}
</style>
